import angular from 'angular';
import {defaultsDeep} from 'lodash';

/**
 * Registers a graph configuration generating function in the 'vrm.graph' module
 * The function is wrapped so that the actual service is an invokable function (no arguments) that runs the given configuration generator function
 * through `$injector.invoke`. This results in the dependencies of the configuration to be "lazely" resolved when the config is actually instatiated.
 * Also every copy of the config is distinct and can be manipulated at will by the callee.
 * @param name The name to register the configuration for in angular
 * @param angularFunction The function which builds the configuration object
 */
export function registerGraph(name, angularFunction) {
    angular.module('vrm.graph').service(name, /* @ngInject */($injector) => () => $injector.invoke(angularFunction));
}

export function mergeGraph(...configs) {
    if (!configs.length) throw new Error('must call createGraphConfig with at least 1 angular factory function');
    configs = Array.from(configs).reverse();
    return defaultsDeep(...configs);
}
